/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_TurkishInputs */



/**
* | output |
* | --- |
* | "Turkish" |
*
* @param {Speechmatics_Target_Language_TurkishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_turkish = /** @type {((inputs?: Speechmatics_Target_Language_TurkishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_TurkishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Turc")
	if (locale === "de") return /** @type {LocalizedString} */ ("Türkisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("turco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("турецкий")
	if (locale === "es") return /** @type {LocalizedString} */ ("turco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("土耳其")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トルコ語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तुर्की")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("turco")
	return /** @type {LocalizedString} */ ("Turkish")
});